import React from "react";
import TourCard from "../../shared/TourCard";
import tourData from "../../assets/data/tours";
import { Col, Button } from "reactstrap";
import { Link } from "react-router-dom";

const FeaturedTourList = () => {
  // Remove the slice method to display all tours
  const displayedTours = tourData;

  return (
    <>
      {displayedTours.map((tour) => (
        <Col lg="3" md="6" sm="6" className="mb-4" key={tour.id}>
          <TourCard tour={tour} />
        </Col>
      ))}

      <Link to="/tour-packages">
        <Button style={{ float: "right" }} className="primary__btn">
          Know more...
        </Button>
      </Link>
    </>
  );
};

export default FeaturedTourList;
